import { render, staticRenderFns } from "./Placeholder1.vue?vue&type=template&id=96145258"
import script from "./Placeholder1.vue?vue&type=script&lang=js"
export * from "./Placeholder1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports